import React, { useState } from 'react';
import { casinoNews } from '../../../mocks/news';

export const NewsSection: React.FC = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextNews = () => {
    setCurrentIndex((prev) => (prev + 1) % casinoNews.length);
  };

  const prevNews = () => {
    setCurrentIndex((prev) => (prev - 1 + casinoNews.length) % casinoNews.length);
  };

  const visibleNews = [
    casinoNews[currentIndex],
    casinoNews[(currentIndex + 1) % casinoNews.length],
    casinoNews[(currentIndex + 2) % casinoNews.length]
  ];

  return (
    <section id="news" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between mb-12">
          <div>
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-2">
              Новости мобильных казино онлайн
            </h2>
            <p className="text-xl text-gray-600">Последние обновления и тренды</p>
          </div>

          <div className="flex gap-3">
            <button
              onClick={prevNews}
              className="w-12 h-12 rounded-full bg-white shadow-md flex items-center justify-center hover:shadow-lg transition-all cursor-pointer"
            >
              <i className="ri-arrow-left-line text-xl"></i>
            </button>
            <button
              onClick={nextNews}
              className="w-12 h-12 rounded-full bg-gray-900 text-white flex items-center justify-center hover:bg-gray-800 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-right-line text-xl"></i>
            </button>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {visibleNews.map((news) => (
            <div
              key={news.id}
              className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 group"
            >
              <div className="h-48 overflow-hidden">
                <img
                  src={news.image}
                  alt={news.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                />
              </div>

              <div className="p-6">
                <div className="flex items-center gap-3 mb-3">
                  <span className="text-xs px-3 py-1 bg-blue-100 text-blue-600 rounded-full font-medium">
                    {news.category}
                  </span>
                  <span className="text-sm text-gray-500">{news.date}</span>
                </div>

                <h3 className="text-xl font-bold text-gray-900 mb-3 leading-tight">
                  {news.title}
                </h3>

                <p className="text-gray-600 text-sm leading-relaxed mb-4">
                  {news.excerpt}
                </p>

                <button className="text-blue-600 font-medium text-sm flex items-center gap-2 hover:gap-3 transition-all cursor-pointer">
                  Читать далее
                  <i className="ri-arrow-right-line"></i>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};